import styled from 'styled-components';

export const HiddenInput = styled.input<{}>`
  display: none !important;
`;

export const FolderContainer = styled.div<{
  disabled?: boolean;
}>`
  cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
  & > * {
    cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
  }
`;

export const DragContainer = styled.div<{ hasError: boolean }>`
  align-items: center;
  border: 2px dashed
    ${({ theme, hasError }) => (hasError ? theme.status.error.color : theme.gray4D)};
  border-radius: 10px;
  color: ${({ theme, hasError }) => (hasError ? theme.status.error.color : theme.gray4D)};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-size: 18px;
  font-weight: 700;
  gap: 24px;
  height: 300px;
  justify-content: center;
  width: 100%;
`;
